import { DefaultTheme } from 'styled-components';
import { MediaQueries, MediaQueryEnum } from '../types';

export const getMediaQueriesMFByTheme = (theme: DefaultTheme): MediaQueries => {
    return {
        [MediaQueryEnum.MOBILE]: `(min-width: ${theme.breakpoints.sm}px)`,
        [MediaQueryEnum.TABLET]: `(min-width: ${theme.breakpoints.md}px)`,
        [MediaQueryEnum.DESKTOP]: `(min-width: ${theme.breakpoints.lg}px)`,
        [MediaQueryEnum.SUPER_DESKTOP]: `(min-width: ${theme.breakpoints.xl}px)`
    };
};
